import { render, staticRenderFns } from "./ClinicPatientCreatePanel.vue?vue&type=template&id=36a9fe49&scoped=true"
import script from "./ClinicPatientCreatePanel.vue?vue&type=script&lang=js"
export * from "./ClinicPatientCreatePanel.vue?vue&type=script&lang=js"
import style0 from "./ClinicPatientCreatePanel.vue?vue&type=style&index=0&id=36a9fe49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a9fe49",
  null
  
)

export default component.exports